import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'Prescription Services', path: '/pharmacy-services', active: true },
  { label: 'Medication Management', path: '/pharmacy-services' },
  { label: 'MAT – Medication Assisted Treatment', path: '/pharmacy-services' },
  { label: 'Prescription Dispensing', path: '/pharmacy-services' },
  { label: 'Over-The-Counter Medication', path: '/pharmacy-services' },
  { label: 'Minor Ailment Prescribing', path: '/pharmacy-services' },
  { label: 'Diabetes Care', path: '/pharmacy-services' },
  { label: 'Immunization & Vaccines', path: '/pharmacy-services' },
  { label: 'Home Healthcare', path: '/pharmacy-services' },
  { label: 'Addiction Services', path: '/addiction-services' },
  { label: 'Methadone Treatment', path: '/methadone-treatment' },
  { label: 'Suboxone Treatment', path: '/suboxone-treatment' },
];

export default function PharmacySidebar() {
  return (
    <>
      {/* Services Category */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="bg-gray-900 px-5 py-4">
          <h2 className="text-xs font-bold text-white tracking-[0.12em] uppercase">Services</h2>
        </div>
        <nav aria-label="Service categories">
          <ul role="list" className="divide-y divide-gray-100">
            {serviceLinks.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.path}
                  className={`flex items-center justify-between px-5 py-3.5 text-sm transition-colors group cursor-pointer ${
                    link.active
                      ? 'bg-teal-50 text-teal-700 font-semibold'
                      : 'text-gray-600 font-medium hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <span>{link.label}</span>
                  <i
                    className={`ri-arrow-right-line text-sm transition-colors ${
                      link.active ? 'text-teal-600' : 'text-gray-300 group-hover:text-gray-600'
                    }`}
                    aria-hidden="true"
                  />
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* Contact Card */}
      <div className="bg-gray-900 rounded-lg p-6 text-white">
        <div className="flex mb-5">
          {[
            'https://readdy.ai/api/search-image?query=professional%20female%20pharmacist%20smiling%20headshot%20neutral%20background%20healthcare%20worker%20portrait&width=80&height=80&seq=pharm-avatar1&orientation=squarish',
            'https://readdy.ai/api/search-image?query=professional%20male%20pharmacist%20smiling%20headshot%20neutral%20background%20healthcare%20worker%20portrait&width=80&height=80&seq=pharm-avatar2&orientation=squarish',
            'https://readdy.ai/api/search-image?query=professional%20female%20doctor%20smiling%20headshot%20neutral%20background%20healthcare%20worker%20portrait&width=80&height=80&seq=pharm-avatar3&orientation=squarish',
          ].map((src, i) => (
            <div
              key={i}
              className="w-10 h-10 rounded-full border-2 border-gray-700 overflow-hidden flex-shrink-0"
              style={{ marginLeft: i === 0 ? 0 : '-8px' }}
            >
              <img src={src} alt="Pharmacist" className="w-full h-full object-cover object-top" width={40} height={40} />
            </div>
          ))}
        </div>
        <p className="text-sm font-semibold mb-1 text-white">Still have any questions?</p>
        <p className="text-xs text-gray-400 mb-5 leading-relaxed">
          Our pharmacists are here to help you anytime.
        </p>
        <a
          href="tel:9057099985"
          className="flex items-center gap-2.5 text-sm text-gray-300 hover:text-white transition-colors cursor-pointer mb-3"
        >
          <i className="ri-phone-line text-teal-400" aria-hidden="true"></i>
          (905) 709-9985
        </a>
        <a
          href="mailto:info@thornhilltreatment.com"
          className="flex items-center gap-2.5 text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-mail-line text-teal-400" aria-hidden="true"></i>
          info@thornhilltreatment.com
        </a>
      </div>

      {/* Quick CTA */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="w-full h-36 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20pharmacist%20at%20prescription%20counter%20smiling%20helping%20a%20customer%20modern%20clean%20pharmacy%20teal%20white%20color%20scheme%20natural%20lighting%20close%20up%20warm%20professional&width=400&height=200&seq=pharm-sidebar-cta&orientation=landscape"
            alt="Thornhill Drug-Mart pharmacist team"
            className="w-full h-full object-cover object-top"
            width={400}
            height={160}
          />
        </div>
        <div className="p-5">
          <h3 className="text-sm font-semibold text-gray-900 mb-1">Get Your Prescription Filled Today</h3>
          <p className="text-xs text-gray-500 mb-4 leading-relaxed">
            Walk in or call ahead — we&apos;ll have it ready fast.
          </p>
          <a
            href="tel:9057099985"
            className="block text-center bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Call Now
          </a>
        </div>
      </div>
    </>
  );
}
